export default {"src":"/_next/static/media/cycling.9b00a369.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};